import request from "@/utils/request";

// 获取工作单位
export function getServicePlaces() {
  return request({
    url: "/platform/settings/employers",
    method: "get",
    params: {}
  });
}

// 获取国籍
export function getNationalities() {
  return request({
    url: "/platform/settings/nationalitys",
    method: "get",
    params: {}
  });
}

// 获取客服资料
export function getServiceInfo() {
  return request({
    url: "/platform/settings/service",
    method: "get",
    params: {}
  });
}

// 获取分享页面地址
export function getShareUrl() {
  return request({
    url: "/platform/settings/show/url",
    method: "get",
    params: {}
  });
}

// 获取下载页面地址
export function getDownloadUrl() {
  return request({
    url: "/platform/settings/download/url",
    method: "get",
    params: {}
  });
}

// 获取视频分类
export function getVideoCategories() {
  return request({
    url: "/platform/settings/video/classification",
    method: "get",
    params: {}
  });
}

export function getServiceId() {
  return request({
    url: "/homepage/getcust",
    method: "get",
    params: {}
  });
}
